const scrollToTop = {
    $scrollButton: undefined,
    appendButton:  () => {
        const $body = $('body'),
                $document = $(document),
                $window = $(window),
                $footer = $('.page-footer'),
                startPosition = 3000;

        $body.append(scrollToTop.buttonTemplate());
        scrollToTop.$scrollButton = $('.scroll-to-top--wrapper');

        if (scrollToTop.$scrollButton) {
            $window.on('scroll', () => scrollToTop.onScrollBehaviour($document, $window, $footer, startPosition));
            scrollToTop.$scrollButton.on('click', () => scrollToTop.onClickAction());
        }
    },

    buttonTemplate: () => `<div class="scroll-to-top--wrapper">
        <button class="scroll-to-top btn-reset">
            <svg class="icon">
                <use xlink:href="#icon-arrow-right-long"></use>
            </svg>
        </button>
    </div>`,

    onScrollBehaviour: ($document, $window, $footer, startPosition) => {
        const currentPos = $document.scrollTop(),
                endPosition = $document.height() - $window.height() - $footer.height();

        currentPos >= startPosition && currentPos <= endPosition ?
                scrollToTop.showButton() :
                scrollToTop.showButton(false);
    },

    showButton(show = true) {
        show ? scrollToTop.$scrollButton.fadeIn('fast') :
                scrollToTop.$scrollButton.fadeOut('fast');
    },

    backToTopInvisible(invisible = true) {
        invisible ?
                scrollToTop.$scrollButton.find('.scroll-to-top').css({right: '-50px'}) :
                scrollToTop.$scrollButton.find('.scroll-to-top').css({right: '20px'});
    },

    onClickAction: () => {
        //Has to be exactly $('html, body')
        $('html, body').animate({scrollTop: 0}, 800, 'swing');
    }
}

$(() => {
    scrollToTop.appendButton();
});

export default scrollToTop;